if (!customElements.get('form-validate')) {
  class FormValidation extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) throw new Error('Form element does not exist');
    }

    toggleErrorMessage(input, field) {
      const errorMessageWrapper =
        field.querySelector('[data-message]');
      errorMessageWrapper.classList.toggle(
        'hidden',
        input.validity.valid
      );
      errorMessageWrapper.parentElement.classList.toggle(
        'has-error',
        !input.validity.valid
      );

      errorMessageWrapper.innerHTML =
        this.getValidationMessage(input);
    }

    getValidationMessage(input) {
      const strings = window.validationStrings || {};

      if (input.validity.customError) {
        return input.validationMessage;
      }

      if (input.validity.valueMissing) {
        return strings.valueMissing || input.validationMessage;
      }

      if (input.validity.typeMismatch) {
        if (input.type === 'email') {
          return strings.invalidEmail || input.validationMessage;
        }
        return strings.typeMismatch || input.validationMessage;
      }

      if (input.validity.patternMismatch) {
        return strings.patternMismatch || input.validationMessage;
      }

      if (input.validity.tooShort) {
        return strings.tooShort || input.validationMessage;
      }

      if (input.validity.tooLong) {
        return strings.tooLong || input.validationMessage;
      }

      if (input.validity.rangeUnderflow) {
        return strings.rangeUnderflow || input.validationMessage;
      }

      if (input.validity.rangeOverflow) {
        return strings.rangeOverflow || input.validationMessage;
      }

      if (input.validity.stepMismatch) {
        return strings.stepMismatch || input.validationMessage;
      }

      if (input.validity.badInput) {
        return strings.badInput || input.validationMessage;
      }

      return input.validationMessage || strings.fallback || '';
    }

    setFieldValidity(input) {
      input.setAttribute('aria-invalid', !input.validity.valid);
      const field = input.closest('[data-input-wrapper]');
      if (!field) return;
      field.classList.toggle('has-error', !input.validity.valid);
      this.toggleErrorMessage(input, field);
    }

    onSubmit(event) {
      if (!this.form.reportValidity()) event.preventDefault();
      this.form.submit();
    }

    setHandlers() {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
      for (const input of this.form.elements) {
        if (input.hasAttribute('data-no-validate')) continue;

        ['input', 'blur', 'change', 'invalid'].forEach(eventName => {
          input.addEventListener(
            eventName,
            this.setInputHandler.bind(this)
          );
        });
      }
    }

    setInputHandler(event) {
      if (event.type === 'invalid') {
        event.preventDefault();
      }

      this.setFieldValidity(event.target);
    }

    connectedCallback() {
      this.setHandlers();
    }
  }

  customElements.define('form-validate', FormValidation);
}
